/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type DeleteShiftSignupSelfMutationVariables = Types.Exact<{
  shift_id: Types.Scalars["Int"];
}>;

export type DeleteShiftSignupSelfMutation = {
  deleteShiftSignupSelf: Pick<Types.Success, "status">;
};

export const DeleteShiftSignupSelfDocument = gql`
  mutation DeleteShiftSignupSelf($shift_id: Int!) {
    deleteShiftSignupSelf(shift_id: $shift_id) {
      status
    }
  }
`;

/**
 * __useDeleteShiftSignupSelfMutation__
 *
 * To run a mutation, you first call `useDeleteShiftSignupSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShiftSignupSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShiftSignupSelfMutation, { data, loading, error }] = useDeleteShiftSignupSelfMutation({
 *   variables: {
 *      shift_id: // value for 'shift_id'
 *   },
 * });
 */
export function useDeleteShiftSignupSelfMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteShiftSignupSelfMutation,
    DeleteShiftSignupSelfMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    DeleteShiftSignupSelfMutation,
    DeleteShiftSignupSelfMutationVariables
  >(DeleteShiftSignupSelfDocument, baseOptions);
}
export type DeleteShiftSignupSelfMutationHookResult = ReturnType<
  typeof useDeleteShiftSignupSelfMutation
>;
export type DeleteShiftSignupSelfMutationResult =
  ApolloReactCommon.MutationResult<DeleteShiftSignupSelfMutation>;
export type DeleteShiftSignupSelfMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteShiftSignupSelfMutation,
    DeleteShiftSignupSelfMutationVariables
  >;
